import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: 'Mandatory field',
  },
  string: {
    min: ({ min }) => `${min} characters minimum`,
    max: ({ max }) => `${max} characters maximum`,
  },
});

export default yup;
